export const headerMainTranslationKeys = {
  paymentsNextPayment: 'payments.next-payment',
  balanceAvailable: 'balance.available',
}
